import React, { useState } from "react";
import { Package, DollarSign, Eye, Headphones, X } from "lucide-react";

const stats = [
  { title: "Doorstep Delivery", Icon: Package },
  { title: "Zero Additional Cost", Icon: DollarSign },
  { title: "Transparency", Icon: Eye },
  { title: "Priority Support", Icon: Headphones },
];

const Thayumanavar = () => {
  const [showApplyPopup, setShowApplyPopup] = useState(false);
  const [showWorksPopup, setShowWorksPopup] = useState(false);

  return (
    <div className="bg-slate-50 font-sans py-12 px-6 md:px-12">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
          THAYUMANAVAR SCHEME
        </h1>
        <p className="mt-2 text-gray-500 md:text-lg">
          A pioneering initiative delivering essential PDS commodities directly to
          the homes of senior citizens and persons with disabilities
        </p>
      </div>

{/* Image + About the Scheme */}
<div className="bg-blue-50 rounded-xl p-8 mb-12">
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">

    {/* Left Image (FULL HEIGHT / FULL AREA) */}
    <div className="w-full flex justify-center">
      <img
        src="/Images/SKM_5638.JPG"
        alt="Thayumanavar Scheme"
        className="rounded-lg shadow-md w-full h-full object-cover max-h-[420px]"
      />
    </div>

    {/* Right Content (FULL AREA) */}
    <div className="w-full">

      <h2 className="text-3xl font-bold text-gray-800 mb-4">
        About the Scheme
      </h2>

     {/* Left border only for text content */}
<div className="border-l-4 border-blue-500 pl-6">
  <p className="text-gray-700 mb-4 leading-relaxed">
    The Thayumanavar Scheme is a people-centric initiative of the Government of
    Tamil Nadu, implemented through the Cooperative Department and PDS network,
    aimed at providing doorstep delivery of ration essentials to:
  </p>

  <ul className="list-disc list-inside text-gray-700 space-y-2 font-medium">
    <li>Senior citizens (above 70 years)</li>
    <li>Persons with disabilities</li>
    <li>Critically ill or bedridden cardholders</li>
    <li>Individuals without regular family support</li>
  </ul>
</div>

      {/* Full width final sentence */}
      <p className="text-gray-700 mt-6">
        The scheme ensures that the most vulnerable members of society receive
        their monthly entitlements safely and conveniently, without the need to
        visit the Fair Price Shop.
      </p>

    </div>
  </div>
</div>

      {/* Key Stats Section */}
<div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] bg-gray-100 p-10 mb-12">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Key Stats</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((stat, i) => {
            const IconComponent = stat.Icon;
            return (
              <div
                key={i}
                className="bg-white p-5 rounded-lg border-2 border-blue-200 flex items-center gap-4"
              >
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm flex-shrink-0">
                  <IconComponent className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-gray-800 font-medium text-sm leading-tight">
                  {stat.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
{/* Who can Apply + How the Scheme Works */}
<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

  {/* Who can Apply */}
  <div
    onClick={() => setShowApplyPopup(true)}
    className="rounded-2xl cursor-pointer transition-all duration-300 shadow-sm hover:shadow-md"
    style={{
      backgroundColor: "#fcf5ff",  
      border: "10px solid #eedbfd",   // ✨ Thick lavender border
    }}
  >
    <div className="p-8">
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 bg-white shadow-sm rounded-xl flex items-center justify-center">
          <Headphones className="w-7 h-7 text-[#6e261e]" />
        </div>
      </div>

      <h2 className="text-xl font-bold text-[#1a1a1a] text-center mb-3">
        Who can Apply?
      </h2>

      <p className="text-gray-700 text-center text-sm">
        Click to view eligibility criteria
      </p>
    </div>
  </div>

  {/* How the Scheme Works */}
  <div
    onClick={() => setShowWorksPopup(true)}
    className="rounded-2xl cursor-pointer transition-all duration-300 shadow-sm hover:shadow-md"
    style={{
      backgroundColor: "#fff8ef",
      border: "10px solid #ffe4c4",   // ✨ Thick peach border
    }}
  >
    <div className="p-8">
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 bg-white shadow-sm rounded-xl flex items-center justify-center">
          <Package className="w-7 h-7 text-[#5f729b]" />
        </div>
      </div>

      <h2 className="text-xl font-bold text-[#1a1a1a] text-center mb-3">
        How the Scheme Works
      </h2>

      <p className="text-gray-700 text-center text-sm">
        Click to view the process
      </p>
    </div>
  </div>

</div>

    {/* Who can Apply Popup */}
{showApplyPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl max-w-lg w-full p-8 relative shadow-2xl">
      <button
        onClick={() => setShowApplyPopup(false)}
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
      >
        <X className="w-6 h-6" />
      </button>

      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        Who Can Apply?
      </h2>

      {/* Enhanced Eligibility Card */}
      <div className="bg-blue-50 rounded-xl p-6 shadow-inner">
        <p className="font-semibold text-gray-800 mb-4">The scheme covers:</p>

 {/* Vertical Step-Style List */}
<div className="space-y-6">
  {[
    "Senior citizens above 70 years",
    "Persons with 40% or more disability",
    "Bedridden or severely ill cardholders",
    "Individuals living alone or without regular assistance",
  ].map((item, idx) => (
    <div key={idx} className="flex items-start relative pl-12">

      {/* Connector line */}
      {idx < 3 && (
        <div className="absolute left-5 top-8 w-0.5 h-full bg-blue-300"></div>
      )}

      {/* Smaller Number Circle */}
      <div className="absolute left-0 flex items-center justify-center 
          w-8 h-8 rounded-full bg-blue-600 text-white text-sm font-semibold shadow">
        {idx + 1}
      </div>

      {/* Label */}
      <p className="text-gray-700 font-medium leading-relaxed">
        {item}
      </p>
    </div>
  ))}
</div>

      </div>

      <p className="text-gray-600 text-sm mt-5 text-center">
        Eligible families can enrol through their nearest Fair Price Shop or Civil Supplies office.
      </p>
    </div>
  </div>
)}


{/* How the Scheme Works Popup */}
{showWorksPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl max-w-xl w-full p-8 relative shadow-2xl">
      <button
        onClick={() => setShowWorksPopup(false)}
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
      >
        <X className="w-6 h-6" />
      </button>

      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">How the Scheme Works</h2>

     {/* Step Flow - Vertical */}
<div className="space-y-6">
  {[
    "Identification & Enrolment",
    "Verification",
    "Monthly Packing",
    "Doorstep Delivery",
    "Confirmation",
  ].map((step, idx) => (
    <div key={idx} className="flex items-start relative pl-12">
      
      {/* Connector line */}
      {idx < 4 && (
        <div className="absolute left-5 top-10 w-0.5 h-full bg-blue-300"></div>
      )}

      {/* Number circle */}
      <div className="absolute left-0 flex items-center justify-center w-10 h-10 rounded-full bg-blue-500 text-white font-semibold">
        {idx + 1}
      </div>

      {/* Step label */}
      <p className="text-gray-700 font-medium leading-relaxed">{step}</p>
    </div>
  ))}
</div>

    </div>
  </div>
)}

    </div>
  );
};

export default Thayumanavar;